import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { COLOR_BACKGROUND_LIGHT , COLOR_TEXT } from '../styles/colors';
import { FONT_PROXIMA_NOVA } from '../styles/fonts';
import MEDIA from '../styles/media';

interface ListItemProps {
  className?: string;
  iconClassName?: string;
  contentClassName?: string;
  icon?: React.ReactNode;
  title: string | React.ReactNode;
  children: any;
  extendWith?: boolean;
  iconCellClassName?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  listItem: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '50px',
    padding: theme.spacing(.5, 2),
    fontFamily: FONT_PROXIMA_NOVA,
    lineHeight: 1.2,
    color: COLOR_TEXT,

    '&:nth-of-type(2n)': {
      background: COLOR_BACKGROUND_LIGHT,
    },

    '@media (max-width: 1680px)': {
      fontSize: theme.typography.pxToRem(15),
    },

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  withIcon: {
    '& $titleCell': {
      marginLeft: theme.spacing(1.5),
    },
    '& $titleCellExtWidth': {
      marginLeft: theme.spacing(1.5),
    },

    [theme.breakpoints.down('md')]: {
      '& $titleCell': {
        marginLeft: 0,
      },
      '& $titleCellExtWidth': {
        marginLeft: 0,
      },
    },
  },

  iconCell: {
    flexShrink: 0,
  },
  icon: {
    width: '26px',
    height: '26px',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  titleCell: {
    flexShrink: 0,
    width: 120,
    whiteSpace: 'break-spaces',
    lineHeight: 1.1,

    '& img': {
      maxWidth: '100%',
    },

    '@media (max-width: 1680px)': {
      // width: 90,
    },
  },

  titleCellExtWidth: {
    width: 200,
    flexShrink: 0,
    whiteSpace: 'break-spaces',

    [theme.breakpoints.down('xs')]: {
      width: 90
    },
  },

  contentCell: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    overflow: 'hidden',
  },
}), { name: ListItem.name });

export default function ListItem (props: ListItemProps) {
  const {
    className,
    contentClassName,
    iconClassName,
    icon,
    title,
    children,
    extendWith = false,
    iconCellClassName
  } = props;
  const classes = useStyles();
  const Icon:any = icon;

  return (
    <div
      className={clsx(
        classes.listItem,
        icon && classes.withIcon,
        className,
      )}
    >
      {icon && (
        <div className={clsx(classes.iconCell, iconCellClassName)}>
          <Icon className={clsx(classes.icon, iconClassName)} />
        </div>
      )}
      { extendWith &&
        <div className={classes.titleCellExtWidth }>{title}</div>
      }
      { !extendWith &&
        <div className={classes.titleCell }>{title}</div>
      }
      <div className={clsx(classes.contentCell, contentClassName)}>
        {children}
      </div>
    </div>
  );
}
